"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledOption = exports.StyledOptionIndex = exports.StyledResponse = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("../../utils/colors");

var _Text = require("../Text/Text");

var _animations = require("../animations.styled");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  width: 100%;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n\n  @media screen and (min-width: ", ") {\n    font-size: 1.125rem;\n    line-height: 1.69rem;\n  }\n\n  @media screen and (min-width: ", ") {\n    font-size: 1.38rem;\n    line-height: 2rem;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0.5rem;\n  background: ", ";\n  width: 2rem;\n  height: 100%;\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n  font-size: 1.15rem;\n  font-weight: bold;\n  box-sizing: border-box;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          animation: none;\n          border: 1px solid ", ";\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n                ", " 0.35s ease 2\n              "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          animation: ", ";\n          border: 1px solid ", ";\n          background: ", ";\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  cursor: pointer;\n  margin-bottom: 1rem;\n  border-radius: 3px;\n  text-decoration: none;\n  color: ", ";\n  padding: 0 0.5rem;\n  padding-left: ", ";\n  position: relative;\n  box-sizing: border-box;\n  position: relative;\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledResponse = _styledComponents.default.div(_templateObject(), function (props) {
  return (0, _colors.normaliseColor)(props.theme.responseItem.textColor, props.theme);
}, function (props) {
  return props.numbering ? '2.5rem' : '0';
}, function (props) {
  return (0, _colors.getRGBOpacity)((0, _colors.normaliseColor)(props.theme.responseItem.hoverBackgroundColor, props.theme), 0.3);
}, function (props) {
  return props.selected ? (0, _styledComponents.css)(_templateObject2(), props.isAnimated ? (0, _styledComponents.css)(_templateObject3(), _animations.SelectAnimation) : 'none', props.theme.colors.actionPrimary300, (0, _colors.getRGBOpacity)((0, _colors.normaliseColor)(props.theme.responseItem.hoverBackgroundColor, props.theme), 0.3)) : (0, _styledComponents.css)(_templateObject4(), (0, _colors.normaliseColor)(props.theme.responseItem.borderColor, props.theme));
});

exports.StyledResponse = StyledResponse;

var StyledOptionIndex = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.selected ? props.theme.colors.actionPrimary300 : (0, _colors.normaliseColor)(props.theme.responseItem.numberingColor, props.theme);
});

exports.StyledOptionIndex = StyledOptionIndex;
var StyledOption = (0, _styledComponents.default)(_Text.Text)(_templateObject6(), function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.xl;
});
exports.StyledOption = StyledOption;